
import Navbar from "./NavBar";
import Herobg2 from "../assets/mobilebgbus.png";

import OurJourneyMobileView from "./OurJourneyMobileView";
import DashboardPrizeMobileView from "./DashboardPrizeMobileView";
import GalleryScreenMobileView from "./GalleryScreenMobileView";
import { useNavigate } from "react-router-dom";

export default function DashBoardMobileView() {
  const navigate = useNavigate();
  return (
    <div>
      <div
      className="relative min-h-screen bg-cover bg-center bg-no-repeat overflow-hidden md:hidden"
      style={{
        backgroundImage: `url(${Herobg2})`,
      }}
    >
     
      <div className="absolute inset-0 bg-black/10 z-0" />

      <div className="fixed top-0 left-0 w-full z-50 backdrop-blur-md bg-black/20 border-b border-white/10">
        <Navbar />
      </div>


      <div className="relative z-10 flex flex-col  justify-between min-h-screen px-6 pt-28 pb-14">

  <div>
        <p
          className="text-green-400 uppercase tracking-[0.25em] text-[11px] font-medium mb-4"
          style={{ fontFamily: "'Barlow Semi Condensed', sans-serif" }}
        >
          India's Next Generation EV Mobility
        </p>

        {/* Main Heading */}
        <h1
          className="text-5xl leading-[0.95] text-white drop-shadow-2xl"
          style={{ fontFamily: "'Racing Sans One', sans-serif" }}
        >
          OHM
          <span className="block text-green-400 mt-1">
            AUTOMOTIVES
          </span>
        </h1>

        {/* Subtitle */}
        <p
          className="mt-5 text-lg text-white leading-snug"
          style={{ fontFamily: "'Barlow Semi Condensed', sans-serif" }}
        >
          Powering Every Journey With Intelligent Electric Mobility
        </p>

        {/* Description */}
        <p
          className="mt-6 text-sm text-white leading-relaxed"
          style={{ fontFamily: "'Roboto', sans-serif" }}
        >
          Proudly pioneering the future of clean transit with{" "}
          <span className="text-green-400 font-medium">
            India’s first commercial electric buses
          </span>{" "}
          engineered using advanced{" "}
          <span className="text-green-400 font-medium">
            BC5 CATL battery technology
          </span>
          , delivering performance, efficiency, and sustainable mobility.
        </p>
  </div>

    

        {/* Bottom Info Cards */}
        <div className="mt-12 grid grid-cols-2 gap-4">
    {/* Buttons */}
       

          <button
           onClick={() => navigate("/electricBus")}
            className="
              bg-green-500
              hover:bg-green-400
              text-black
              font-semibold
              uppercase
              tracking-[0.18em]
              text-xs
              py-4
              rounded-lg
              transition-all
              duration-300
              shadow-xl
            "
          >
            Explore Products
          </button>

          <button
          onClick={() => navigate("/contact")}
            className="
              border
              border-white/20
              backdrop-blur-md
              hover:bg-white/10
              text-white
              uppercase
              tracking-[0.18em]
              text-xs
              py-4
              rounded-lg
              transition-all
              duration-300
            "
          >
            Contact Us
          </button>
     
        </div>
      </div>

      {/* Bottom Gradient */}
      <div className="absolute bottom-0 left-0 w-full h-32 bg-gradient-to-t from-black to-transparent z-0" />
    </div>
      <OurJourneyMobileView />
      <GalleryScreenMobileView />
      <DashboardPrizeMobileView />
    </div>
  );
}
